// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-raised-button.mat-gray {
  background-color: #757575 !important; /* Darker gray for better contrast with white text */
  color: #ffffff !important; /* Explicit white for 4.6:1 contrast ratio */
  border: 1px solid #666666 !important; /* Border for additional definition */
}

.mat-mdc-card-header {
  padding: 5px !important;
  background-color: #337ab7 !important;
  color: #ffffff !important; /* Explicit white text */
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
  border: 1px solid #1e3a6f !important; /* Darker border for definition */
}

.mat-mdc-card {
  padding: 0 !important;
}

.mat-mdc-card-content {
  padding: 5px !important;
}

.expand {
  flex-grow: 2;
}

.white-text {
  color: white;
}

.center {
  text-align: center;
}

.survey-title {
  font-size: 28px;
}

.mat-mdc-card-actions {
  margin-left: -8px;
  margin-right: -8px;
  padding: 8px 0;
}

.mat-mdc-card-actions, .mat-mdc-card-subtitle, .mat-mdc-card-content {
  display: block;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/survey/components/survey.component.scss"],"names":[],"mappings":"AAKA;EACE,oCAAA,EAAA,oDAAA;EACA,yBAAA,EAAA,4CAAA;EACA,oCAAA,EAAA,qCAAA;AAJF;;AAOA;EACE,uBAAA;EACA,oCAAA;EACA,yBAAA,EAAA,wBAAA;EACA,uCAAA;EACA,sCAAA;EACA,oCAAA,EAAA,iCAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,mBAAA;AAJF","sourcesContent":["// .mat-raised-button.mat-blue {\r\n//   background-color: #5479b9;\r\n//   color: white;\r\n// }\r\n\r\n.mat-mdc-raised-button.mat-gray {\r\n  background-color: #757575 !important; /* Darker gray for better contrast with white text */\r\n  color: #ffffff !important; /* Explicit white for 4.6:1 contrast ratio */\r\n  border: 1px solid #666666 !important; /* Border for additional definition */\r\n}\r\n\r\n.mat-mdc-card-header {\r\n  padding: 5px !important;\r\n  background-color: #337ab7  !important;\r\n  color: #ffffff !important; /* Explicit white text */\r\n  border-top-right-radius: 4px !important;\r\n  border-top-left-radius: 4px !important;\r\n  border: 1px solid #1e3a6f !important; /* Darker border for definition */\r\n}\r\n\r\n.mat-mdc-card {\r\n  padding: 0 !important;\r\n}\r\n\r\n.mat-mdc-card-content {\r\n  padding: 5px !important;\r\n}\r\n\r\n.expand {\r\n  flex-grow: 2;\r\n}\r\n\r\n.white-text {\r\n  color: white;\r\n}\r\n\r\n.center {\r\n  text-align: center;\r\n}\r\n\r\n.survey-title {\r\n  font-size: 28px;\r\n}\r\n\r\n.mat-mdc-card-actions {\r\n  margin-left: -8px;\r\n  margin-right: -8px;\r\n  padding: 8px 0;\r\n}\r\n\r\n.mat-mdc-card-actions, .mat-mdc-card-subtitle, .mat-mdc-card-content {\r\n  display: block;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
